'use client';

import React from 'react';
import Hero from './index';
import { usePreviewState } from '@/context/PreviewStateProvider';
import { getGuestWelcomeMessage } from '@/models';

interface PreviewAwareHeroProps {
  defaultContent: any;
  settings: any;
  variant: 'header' | 'fullScreen';
}

/**
 * Preview-aware Hero component that updates with real-time preview data
 * Uses preview state from context when available, falls back to default content
 */
const PreviewAwareHero: React.FC<PreviewAwareHeroProps> = ({
  defaultContent,
  settings,
  variant = 'header',
}) => {
  const previewContext = usePreviewState();

  // Use preview content if available, otherwise use default
  const content = previewContext?.previewData?.content || defaultContent;

  return (
    <Hero
      section={{
        settings: {
          image_url: content?.thumbnail || settings.whistle_guest_hero,
        },
        plain_text:
          getGuestWelcomeMessage(content) ??
          settings.whistle_guest_company_name,
      }}
      variant={variant}
    />
  );
};

export default PreviewAwareHero;
